import { ButtonProps } from '@material-ui/core';
import React from 'react';
import { color as responsiveColor } from 'styled-system';
import { Button } from '~frontend-common/components/buttons';
import { css, styled } from '~ui-kit/styled-components';

/** Render a simple button with only text */
export const TextButton: React.FunctionComponent<ButtonProps & { display?: React.CSSProperties['display'] }> = ({
  disabled = false,
  id,
  onClick,
  children,
  display,
  ...rest
}) => {
  return (
    <StyledButton {...rest} onClick={onClick} disabled={disabled} id={id} $display={display}>
      {children}
    </StyledButton>
  );
};

const StyledButton = styled(({ color, children, ...rest }) => <Button {...rest}>{children}</Button>)<{
  $display?: React.CSSProperties['display'];
}>`
  && {
    padding: 0px;
    min-width: 0px;
    min-height: 0px;
    text-transform: none;
    ${({ $display }) =>
      $display
        ? css`
            display: ${$display};
            vertical-align: text-top;
          `
        : ''}
    ${responsiveColor};
  }
`;
